import { MsalProvider } from '@azure/msal-react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';
import { msalInstance } from './auth/msal';
// Note: formio + its CSS are NOT imported here — they are pulled in lazily by the
// FormioBuilder chunk only when a form is actually opened, so the app shell and
// sign-in screen paint immediately instead of waiting on ~2 MB of formio JS.
import './styles.css';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found.');
}

void msalInstance.initialize().then(() => {
  ReactDOM.createRoot(rootElement).render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>,
  );
});
